import { render } from "./BulletinTop5.vue?vue&type=template&id=a2389b8e"
import script from "./BulletinTop5.vue?vue&type=script&lang=js"
export * from "./BulletinTop5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__